import { render, staticRenderFns } from "./CorregirCumplimientos.vue?vue&type=template&id=a79b1cfa&scoped=true&"
import script from "./CorregirCumplimientos.vue?vue&type=script&lang=ts&"
export * from "./CorregirCumplimientos.vue?vue&type=script&lang=ts&"
import style0 from "./CorregirCumplimientos.vue?vue&type=style&index=0&id=a79b1cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79b1cfa",
  null
  
)

export default component.exports